"use client";
import { useFormStatus } from "react-dom";
import { Button } from "./button";
import { ReactNode } from "react";

export function SubmitButton({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const { pending } = useFormStatus();
  return (
    <Button className={className} type="submit" loading={pending}>
      {children}
    </Button>
  );
}
